export const SET_ORDER_DETAILS = 'SET_ORDER_DETAILS';

